import { render } from "./HouseRental.vue?vue&type=template&id=3246f114&scoped=true"
import script from "./HouseRental.vue?vue&type=script&lang=js"
export * from "./HouseRental.vue?vue&type=script&lang=js"

import "./HouseRental.vue?vue&type=style&index=0&id=3246f114&scoped=true&lang=css"

import exportComponent from "/Users/apple/Projects/opm/yuzhangmen/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3246f114"]])

export default __exports__